module.exports = {
          srcSet: __webpack_public_path__ + "public/images/6172f61cab562e5c9e7b7be8106618e9-1920.jpg"+" 1920w",
          images:[ {path: __webpack_public_path__ + "public/images/6172f61cab562e5c9e7b7be8106618e9-1920.jpg",width: 1920,height: 687}],
          src: __webpack_public_path__ + "public/images/6172f61cab562e5c9e7b7be8106618e9-1920.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/6172f61cab562e5c9e7b7be8106618e9-1920.jpg"},
          
          width: 1920,
          height: 687
        }